import {ROUTES} from '../../../config/index.js'

export async function getInitialProps({context: {domain}, routeInfo: {location}}) {
  const {
    query: {adId, reservationId}
  } = location

  const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})

  const [reservationError, reservationResponse] = await domain
    .get('get_reservation_by_id_transactions_use_case')
    .execute({reservationId})

  if (adDetailsError || reservationError) {
    return {
      __HTTP__: {
        redirectTo: ROUTES.RESERVATION.REFUND_ERROR
      }
    }
  }

  return {
    ad: adDetailsResponse?.ad,
    adId: adDetailsResponse.ad?.id,
    adPrice: adDetailsResponse.ad?.price,
    adTitle: adDetailsResponse.ad?.title,
    adFinancingData: adDetailsResponse?.financingData,
    reservation: reservationResponse?.value,
    reservationId
  }
}
